export interface LeagueMemberForInvite {
  player_id: string;
  is_deleted?: boolean;
  player?: {
    id?: string;
    name?: string;
    email?: string;
    clerk_user_id?: string | null;
  } | null;
}

export function eligibleLinkedInviteMembers(members: LeagueMemberForInvite[]): LeagueMemberForInvite[] {
  return members
    .filter((member) => !member.is_deleted)
    .filter((member) => member.player && !member.player.clerk_user_id)
    .sort((left, right) => {
      const leftName = (left.player?.name || left.player_id).toLowerCase();
      const rightName = (right.player?.name || right.player_id).toLowerCase();
      return leftName.localeCompare(rightName);
    });
}

export function inviteTargetLabel(
  invite: { player_id?: string | null; season_id?: string | null; scope?: 'league' | 'season' },
  membersByPlayerId: Map<string, LeagueMemberForInvite>,
  seasonNameById: Map<string, string>,
): string {
  if (invite.player_id) {
    const member = membersByPlayerId.get(invite.player_id);
    return member?.player?.name || invite.player_id;
  }

  if (invite.scope === 'season') {
    return seasonNameById.get(invite.season_id || '') || invite.season_id || 'Unknown season';
  }

  return 'Entire league';
}
